import { Action, ActionCreator } from 'redux';
import { Video } from './video';

export const SETCURRENTVIDEO = 'SETCURRENTVIDEO';
export interface SetCurrentVideoAction extends Action {
    video: Video;
}

export const setCurrentVideo: ActionCreator<SetCurrentVideoAction> =
    (video) => ({
        type: SETCURRENTVIDEO,
        video: video
    });

export const SETCURRENTLANGUAGE = 'SETCURRENTLANGUAGE';
export interface SetCurrentLanguageAction extends Action {
    language: any;
}

export const SetCurrentLanguage: ActionCreator<SetCurrentLanguageAction> =
    (language) => ({
        type: SETCURRENTLANGUAGE,
        language: language
    });

export const PATCHPLAYLISTS = 'PATCHPLAYLISTS';
export interface PatchPlayListsAction extends Action {
    videos: any;
}

export const PatchPlayLists: ActionCreator<PatchPlayListsAction> =
    (videos) => ({
        type: SETCURRENTVIDEO,
        videos: videos
    });


export const ADDSHARECOUNTER = 'ADDSHARECOUNTER';
export interface AddShareCounterAction extends Action {
    videos: any;
}

export const AddShareCounter: ActionCreator<AddShareCounterAction> =
    (videos) => ({
        type: SETCURRENTVIDEO,
        videos: videos
    });
